import type { MasteryMapDomain, MasteryMapStandard } from '@ts-mastery-map/interfaces'
import type { MasteryMapStore } from './interfaces'

import { findDomain, sortStandards } from '@helpers/mastery-map'

export const getters = {
  getDocument: (state: MasteryMapStore): MasteryMapStore['document'] => state.document,
  isLoading: (state: MasteryMapStore): MasteryMapStore['loading'] => state.loading,
  hasDocument: (state: MasteryMapStore): boolean => state.document !== null,
  getList: (state: MasteryMapStore): MasteryMapStore['list'] => state.list,
  isListLoading: (state: MasteryMapStore): MasteryMapStore['listLoading'] => state.listLoading,
  hasList: (state: MasteryMapStore): boolean => state.list.length > 0,
  getStrongestDomain: (state: MasteryMapStore): MasteryMapDomain | null =>
    findDomain(state.document, state.document?.strongest_domain ?? null),
  getFocusDomain: (state: MasteryMapStore): MasteryMapDomain | null =>
    findDomain(state.document, state.document?.focus_domain ?? null),
  getSortedStandards: (state: MasteryMapStore): MasteryMapStandard[] =>
    sortStandards(state.document?.standards ?? []),
}
